import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../app/guards'
import { purchasesBySupplierSearchSchema } from '../../features/reports/operational-search'
import { PurchasesBySupplierPage } from '../../features/reports/purchases-by-supplier-page'

export const Route = createFileRoute('/_app/purchases-by-supplier')({
  staticData: { crumb: 'purchasesBySupplier' },
  validateSearch: purchasesBySupplierSearchSchema,
  // It names every supplier: suppliers.read too (G26), as the API.
  beforeLoad: ({ context }) => requireAccess(context.session, ['purchasing.read', 'suppliers.read']),
  component: PurchasesBySupplierPage,
})
